import { OwlDateTimeIntl } from '@danielmoncada/angular-datetime-picker';

export class CzechOwlDateTimeIntl extends OwlDateTimeIntl {
    cancelBtnLabel = 'Zrušit';
    setBtnLabel = 'Potvrdit';
    clearBtnLabel = 'Vymazat';
    closeBtnLabel = 'Zavřít';
    todayBtnLabel = 'Dnes';
    nowBtnLabel = 'Nyní';
    amBtnLabel = 'AM';
    pmBtnLabel = 'PM';
    upSecondLabel = 'Přidat sekundu';
    downSecondLabel = 'Odebrat sekundu';
    upMinuteLabel = 'Přidat minutu';
    downMinuteLabel = 'Odebrat minutu';
    upHourLabel = 'Přidat hodinu';
    downHourLabel = 'Odebrat hodinu';
    prevMonthLabel = 'Předchozí měsíc';
    nextMonthLabel = 'Další měsíc';
    prevYearLabel = 'Předchozí rok';
    nextYearLabel = 'Další rok';
    prevMultiYearLabel = 'Předchozích 21 let';
    nextMultiYearLabel = 'Dalších 21 let';
    switchToMonthViewLabel = 'Přepnout na zobrazení měsíce';
    switchToMultiYearViewLabel = 'Vybrat měsíc a rok';
    switchToDayViewLabel = 'Přepnout na zobrazení dne';
    switchToHourViewLabel = 'Přepnout na zobrazení hodin';
    switchToMinuteViewLabel = 'Přepnout na zobrazení minut';
    switchToSecondViewLabel = 'Přepnout na zobrazení sekund';
}
